import { Tbody as ChakraTableBody, Tr as ChakraTableRow, Td as ChakraTableCell, Box } from '@chakra-ui/react';
import { useMultiStyleConfig } from '@chakra-ui/system';
import { mergeWith } from '@chakra-ui/utils';
import { flexRender } from '@tanstack/react-table';
import React from 'react';

import { useTableExperimentalContext } from './TableExperimentalContext';
import { TableExperimentalColumnDef, TableBodyProps } from './TableTypes';

import Checkbox from 'atoms/Checkbox/Checkbox';

const TableBody = (props: TableBodyProps): React.ReactElement => {
  const { tdCheckboxSx } = props;
  const tableContext = useTableExperimentalContext();
  const { reactTable, isRowSelectionEnabled } = tableContext;

  const themeStyles = useMultiStyleConfig('TableExperimental', { ...tableContext });

  return (
    <ChakraTableBody>
      {reactTable.getRowModel().rows.map(row => {
        const handleRowClick = () => {
          tableContext.onRowClick?.(row);
        };

        return (
          <ChakraTableRow
            data-is-selected={isRowSelectionEnabled ? row.getIsSelected() : undefined}
            key={row.id}
            onClick={handleRowClick}
            onKeyPress={handleRowClick}
            tabIndex={tableContext.onRowClick ? 0 : undefined}
          >
            {row.getVisibleCells().map((cell, index) => {
              const columnDef = cell.column.columnDef as TableExperimentalColumnDef<Record<string, unknown>>;
              return (
                <ChakraTableCell key={cell.id} minWidth={cell.column.getSize()} width={cell.column.getSize()}>
                  <Box display="flex" justifyContent={columnDef.align === 'right' ? 'end' : 'start'}>
                    {isRowSelectionEnabled && index === 0 && (
                      <Checkbox
                        alignItems="start"
                        aria-label="Toogle row selection"
                        isChecked={row.getIsSelected()}
                        isIndeterminate={row.getIsSomeSelected()}
                        onChange={row.getToggleSelectedHandler()}
                        sx={mergeWith(themeStyles.tdCheckbox, tdCheckboxSx)}
                      />
                    )}
                    {flexRender(arg => {
                      if (typeof cell.column.columnDef.cell === 'function') {
                        return cell.column.columnDef.cell(arg) || <Box __css={themeStyles.dash}>–</Box>;
                      }

                      return <Box __css={themeStyles.dash}>–</Box>;
                    }, cell.getContext())}
                  </Box>
                </ChakraTableCell>
              );
            })}
          </ChakraTableRow>
        );
      })}
    </ChakraTableBody>
  );
};

export default TableBody;
